import React from 'react';
import classNames from 'classnames';
import { Button } from '../../../Button';
import "./styles.css";
export var ButtonContainer = function (_a) {
    var actions = _a.actions, className = _a.className;
    return (React.createElement("div", { className: classNames('banner-button-container', className) }, actions.map(function (_a) {
        var startIcon = _a.startIcon, label = _a.label, onClick = _a.onClick;
        return (React.createElement(Button, { startIcon: startIcon, key: label, size: 'small', variant: 'overlay', onClick: onClick, className: 'banner-button' }, label));
    })));
};
